import React, { useEffect, useState, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/admins/adminsActions";
import * as usercrud from "../../../_redux/users/usersCrud";
import * as uiHelpers from "../AdminsUIHelpers";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { getRowStyleByStatus } from "../../../_helpers/tableRowStatusColors";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useAdminsUIContext } from "../AdminsUIContext";
import { initialFilter } from "../AdminsUIHelpers";
export function AdminsTable() {
  // Admins UI Context
  const adminsUIContext = useAdminsUIContext();
  const adminsUIProps = useMemo(() => {
    return {
      ids: adminsUIContext.ids,
      setIds: adminsUIContext.setIds,
      queryParams: adminsUIContext.queryParams,
      setQueryParams: adminsUIContext.setQueryParams,
      openEditAdminPage: adminsUIContext.openEditAdminPage,
      openDeleteAdminDialog: adminsUIContext.openDeleteAdminDialog,
    };
  }, [adminsUIContext]);

  // Getting curret state of admins list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.admins }),
    shallowEqual
  );
  const { user } = useSelector(state => state.auth);
  if (user?.userData?.userid) {
    initialFilter.filter.current_userid = user.userData.userid;
  }
  const { totalCount, entities, listLoading } = currentState;
  const delay = ms => new Promise(res => setTimeout(res, ms));

  const [processing, setProcessing] = useState('');
  const [isEdit, setisEdit] = useState('');
  const [emailValue, setEmailValue] = useState('');
  const [nameValue, setNameValue] = useState('');

  // Admins Redux state
  const dispatch = useDispatch();

  const updateStatus = async (id, status) => {
    setProcessing(id)
    await usercrud.updateStatusForUser(id, status);
    await delay(1000);
    dispatch(actions.fetchAdmins(adminsUIProps.queryParams));
    setProcessing('')
  };

  const editUser = async (row) => {
    setisEdit(row.id)
    setEmailValue(row.email)
    setNameValue(row.name)
  };

  const saveUser = async (row) => {
    setProcessing("save" + row.id)
    await usercrud.updateRecordForUser(row.id, nameValue, emailValue);
    await delay(1000);
    dispatch(actions.fetchAdmins(adminsUIProps.queryParams));
    setisEdit('')
    setProcessing('')
  };
  const rowStyle = (row) => getRowStyleByStatus(row, 'status');

  useEffect(() => {
    // clear selections list
    adminsUIProps.setIds([]);
    // server call by queryParams
    dispatch(actions.fetchAdmins(adminsUIProps.queryParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminsUIProps.queryParams, dispatch]);
  // Table columns
  const columns = [
    {
      attrs: {title: 'NAME'},
      dataField: "name",
      text: "Name",
      formatter: columnFormatters.NameColumnFormatter,
      formatExtraData: {
        isEdit:isEdit,
        setNameValue:setNameValue,
        nameValue:nameValue,
      },
      sort: true,
      sortCaret: sortCaret,
    },
	  {
      attrs: {title: 'EMAIL'},
      dataField: "email",
      text: "Email",
      formatter: columnFormatters.EmailColumnFormatter,
      formatExtraData: {
        isEdit:isEdit,
        setEmailValue:setEmailValue,
        emailValue:emailValue,
      },
      sort: true,
      sortCaret: sortCaret,
    },
    {
      attrs: { title: 'STATUS' },
      dataField: "status",
      text: "Status",
      formatter: columnFormatters.StatusColumnFormatter,
      formatExtraData: {
        updateStatus: updateStatus,
        processing:processing,
      },
      classes: "media-action-class",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      attrs: { title: 'ACTION' },
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        editUser:editUser,
        saveUser:saveUser,
        isEdit:isEdit,
        processing:processing,
        setisEdit:setisEdit,
        openDeleteAdminDialog: adminsUIProps.openDeleteAdminDialog,
      },
      classes: "media-action-class",
      style: {
        minWidth: "100px",
      },
    },
  ];
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: adminsUIProps.queryParams.pageSize,
    page: adminsUIProps.queryParams.pageNumber,
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="custom-res-table table table-head-custom table-head-bg table-vertical-center"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  adminsUIProps.setQueryParams
                )}
                rowStyle={ rowStyle } 
                selectRow={getSelectRow({
                  entities,
                  ids: adminsUIProps.ids,
                  setIds: adminsUIProps.setIds,
                })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
